import { apiClient } from "@/lib/api-client";

export type UnsurMembimbingTaData = Record<string, any>;

export type UnsurMembimbingTaResponse = {
  datas: UnsurMembimbingTaData;
  message: string;
};

export const fetchUnsurMembimbingTa = async ({
  niu,
  year,
  semester,
  periodeID,
}: {
  niu: string;
  year: number;
  semester: number;
  periodeID?: number | null;
}): Promise<UnsurMembimbingTaData> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  const params = new URLSearchParams({
    year: year.toString(),
    semester: semester.toString(),
    ...(periodeID && { periodeID: periodeID.toString() }),
  });

  const resData = await apiClient<UnsurMembimbingTaResponse>(
    `${baseUrl}/api/v1/unsur-membimbing-ta/${niu}?${params.toString()}`,
    {
      headers: {
        Accept: "application/json",
      },
    }
  );

  return resData.datas;
};
